import React, {useState, initialState} from 'react';
import { Button } from '@material-ui/core';
import loginLogo from '../images/logo.png';



function Login() {

    const [ID, setID] = useState(initialState)
    const [Password, setPassword] = useState(initialState)

    const onIDHandler = (event) => {
        setImmediate(event.currentTarget.value)
    }

    const onPasswordHandler = (event) => {
        setPassword(event.currentTarget.value)
    }

    const onSubmitHandler = (event) => {
        event.preventDefault();
    }

    return (
        <div className='login-content'> 
            <div className='login-box'>
                <div className='login-logo'>
                    <img src={loginLogo}  alt="logo-img" style={{width: '150px', padding:'15px'}} />
                </div>
                <form className='login-form' onSubmit={onSubmitHandler}>
                    <label>ID</label>
                    <input type="ID" value={ID} onChange={onIDHandler} className='login-input'/>
                    <label>Password</label>
                    <input type="password" value={Password} onChange={onPasswordHandler} className='login-input' />
                    <br />
                    <Button style={{fontSize: "18px", backgroundColor:'#9DFEC4', color:"#FFF"  }} variant="contained" >
                        Login
					</Button>
                </form>
            </div>
        </div>
    )
}

export default Login;